/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import classnames from "classnames";

import { Button, Confirm, useNotify, useRedirect } from "react-admin";

import { ResourceType } from "../../../../utils/constants";
import { DeleteIcon } from "../../../../components/common/iconography";
import { logError, logHistory } from "../../../../utils/appUtils";
import { deepRedirect } from "../../../../utils/utils";
import { getChargeRuleLabel, softDeleteChargeRules } from "./ChargeRuleUtils";
import { useDeleteButtonStyles } from "../../../../components/common/useDeleteButtonStyles";

export const DeepDeleteButton = ({
  record,
  backPath,
  className,
  isDeleting,
  setIsDeleting,
  isSaving,
  ...props
}) => {
  const classes = useDeleteButtonStyles();
  const history = useHistory();
  const notify = useNotify();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleDelete = async (event) => {
    setIsDeleting(true);

    try {
      const { deleted, failed } = await softDeleteChargeRules([record]);
      if (failed.length) throw failed[0].reason;
      if (!deleted.length) throw new Error("Rule was not deleted");

      const historyNote = {
        parentId: record.accountId,
        parentType: ResourceType.ACCOUNT,
        text: `Billing Rule ${getChargeRuleLabel(record)} deleted.`,
      };
      logHistory(historyNote);

      notify("Rule deleted successfully", "success");
      deepRedirect(history, backPath);
    } catch (error) {
      logError(
        "chargeRules:DeepDeleteButton:handleRemove",
        error,
        notify,
        redirect,
      );
    } finally {
      setIsDeleting(false);
      setOpen(false);
    }
  };

  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={isDeleting || isSaving}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={isDeleting}
        title={"Delete Confirmation"}
        content={
          "This Billing Rule will no longer be available for new charges. " +
          "Charges already added to open shipments will still be billed. Continue?"
        }
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
